import Api from "../apiService";

class CargoPropertiesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/cargo/properties`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/cargo/properties/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/cargo/properties`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/properties/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/properties/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/properties/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }
}

export default new CargoPropertiesApi();
